import toast from 'react-hot-toast'
import { useLocation } from '#router'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { trpc } from '@/lib/trpc'

interface DeleteListDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  listId: string
  listName: string
}

export function DeleteListDialog({
  open,
  onOpenChange,
  listId,
  listName,
}: DeleteListDialogProps) {
  const { navigate } = useLocation()
  const utils = trpc.useUtils()

  const deleteMutation = trpc.lists.delete.useMutation({
    onSuccess: () => {
      utils.lists.getUserListData.invalidate()
      onOpenChange(false)
      navigate('/problems')
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to delete list')
    },
  })

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete list</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete &ldquo;{listName}&rdquo;? This
            action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => deleteMutation.mutate({ listId })}
            disabled={deleteMutation.isPending}
            className="bg-destructive text-white hover:bg-destructive/90"
          >
            {deleteMutation.isPending ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
